/** @type {IApiConfig} */
const config = {
  production: false,
  region: 'th',
  environment: 'beta',
  api: 'https://beta-th-node.dimorder.com/',
  customerApi: 'https://beta-th-customer-api.dimorder.com/',
  deliveryApi: 'https://beta-th-delivery-api.dimorder.com/',
  dimboxApi: 'https://th-box-api.dimorder.com',
  goAdminApi: 'https://beta-th-admin-api.dimorder.com/',
  quickPayApi: 'https://beta-th-quickpaylink-api.dimorder.com/',
  receipt: 'https://beta-th-receipt.dimorder.com/',
  notificationSocketUrl: 'wss://beta-th-api.dimorder.com/a/notification/subscribe',
  clientUrl: 'https://beta-th.dimorder.com',
  clientNewUrl: 'https://beta-th-c.dimorder.com',
  clientWaiterUrl: 'https://beta-th-waiter.dimorder.com',
  dashboardUrl: 'https://beta-th-dimorder-dashboard.web.app',
  reportUrl: 'https://beta-th-dimorder-report.web.app',
  mpUrl: 'https://beta-th-mp.dimorder.com',
  firebase: {
    apiKey: 'AIzaSyDeRY1k_RB8i5ewT422sPQiOfCGYE-QMVg',
    authDomain: 'dimorder-beta-th.firebaseapp.com',
    databaseURL: 'https://dimorder-beta-th-default-rtdb.asia-southeast1.firebasedatabase.app',
    projectId: 'dimorder-beta-th',
    storageBucket: 'dimorder-beta-th.firebasestorage.app',
    messagingSenderId: '872072493059',
    appId: '1:872072493059:web:1c18a41740acbbc12d3636',
  },
}

export default config
